import React from "react";
import {getImagePage, getImagePagePaths} from '../../../lib/image_page'
import {useRouter} from 'next/router'
import urljoin from 'url-join'
import HeadTitle from '../../../components/head_title'
import Layout from '../../../components/layout/layout'
import Loading from '../../../components/loading'
import {extractAxiosError} from '../../../utils/error'
import Api from '../../../service/api'
import {getStaticPaths as getRegionStaticPaths} from '../index'
import TimeoutAlert from "../../../components/timeout_alert";
import {wrapper} from "../../../store/store";
import * as staticProps from '../../../lib/static_props'
import {handleCountryCodeCases} from '../../../lib/static_props'
import {ImagePage} from "../../../types/models/image_page";
import {useQuery} from "../../../hooks/use_query";
import {ParsedUrlQuery} from "querystring";
import HotspotsOverlay from "../../../components/image_page/hotspot_overlay";
import moment from "moment";

export interface ImagePagePageProps {
  imagePage: ImagePage;
}
export default function ImagePagePage({imagePage}: ImagePagePageProps) {
  const router = useRouter()
  if (router.isFallback) {
    return <Loading />
  }
  
  const [errorMessage, setErrorMessage] = React.useState<string | null>(null)
  const [updatedImagePage, setUpdatedImagePage] = React.useState<ImagePage | null>(null)

  const pagePath = useQuery('pagePath');

  React.useEffect(() => {
    if (!pagePath) {
      return;
    }

    Api.imagePage.get(pagePath)
      .then(res => {
        setUpdatedImagePage(res.data.imagePage)
      })
      .catch(error => {
        if (error.response.status === 401) {
          router.push('/404')
        } else {
          setErrorMessage(extractAxiosError(error))
        }
      })
  }, [])

  

  let appliedImagePage = imagePage
  if (updatedImagePage) {
    appliedImagePage = updatedImagePage
  }

  return <Layout>
    <HeadTitle
      title={appliedImagePage.name}
    />
    <TimeoutAlert
      message={errorMessage}
      onHide={() => setErrorMessage(null)}
    />

    <div className="d-inline-block py-1">
      <div className="position-relative">
        <img src={urljoin(process.env.NEXT_PUBLIC_IMAGES_ENDPOINT!, appliedImagePage.imagePath)} alt="page" className="img-fluid" />
        <HotspotsOverlay
          hotspots={appliedImagePage.hotspots}
        />
      </div>
    </div>
  </Layout>
}

export interface ImagePagePageParams extends ParsedUrlQuery {
  pagePath: string;
}

export const getStaticProps = wrapper.getStaticProps<ImagePagePageProps>((store) => handleCountryCodeCases(async function(context) {
  const params = context.params as ImagePagePageParams;
  const imagePage = await getImagePage(params.pagePath);
  const countryCodeProps = staticProps.countryCode(params)
  const props: ImagePagePageProps = {
    imagePage: imagePage as ImagePage,
    ...countryCodeProps
  }
  await staticProps.populateServerSideStore(store.dispatch)

  return {
    props,
    revalidate: moment.duration(1, 'day').as('seconds'),
  }
}, (context) => {
  const params = context.params as ImagePagePageParams;
  return urljoin('ipage', params.pagePath);
}));



export async function getStaticPaths() {
  const paths = [];

  const regionStaticPaths = await getRegionStaticPaths();
  const regionPaths = regionStaticPaths.paths;

  const imagePaths = await getImagePagePaths();

  for (const regionPath of regionPaths) {
    for (const imagePath of imagePaths) {
      paths.push({
        params: {
          pagePath: imagePath.params.pagePath,
          countryCode: regionPath.params.countryCode
        }
      });
    }
  }

  return {
    paths,
    fallback: true
  }
}
